import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SingleNotification } from "../models/user.models";

export interface NotificationState {
  notifications: SingleNotification[];
  unreadCount: number;
}

const reducers = {
  setNotifications: (
    state: NotificationState,
    action: PayloadAction<SingleNotification[]>
  ) => {
    state.notifications = action.payload;
    state.unreadCount = action.payload.filter(
      (notification) => !notification.isSeen
    ).length;
  },

  readAllNotifications: (state: NotificationState) => {
    state.notifications.forEach((notification) => {
      notification.isSeen = true;
    });
    state.unreadCount = 0;
  },
};

const initialState: NotificationState = {
  notifications: [],
  unreadCount: 0,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers,
});

export const { setNotifications, readAllNotifications } =
  notificationSlice.actions;

export default notificationSlice.reducer;
